<template>
  <div>
    <div class="page-header">
      <h1>
        <i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}
        {{ getConsecutive }}
      </h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="p-20 mb-10 card-base card-shadow--small ">
      <!-- buttons -->
      <el-row :gutter="10" class="pb-20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="mb-10 flex-menu-one">
          <el-button :type="editDocument ? 'warning' : 'primary'" size="small" @click="save()" icon="el-icon-check"
            :loading="loading" :disabled="inventoryAuditId == null">
            {{ editDocument ? 'Actualizar' : 'Guardar' }}
          </el-button>
          <el-button type="info" size="small" @click="printDocument()" icon="el-icon-printer" v-if="editDocument">
            Imprimir
          </el-button>
          <el-button type="default" size="small" @click="reset()" icon="el-icon-refresh-left">
            Cancelar
          </el-button>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="flex-menu">
          <list-pending-component />
          <list-component />
          <list-log-component />
        </el-col>
      </el-row>
      <!-- fields -->
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5" :offset="0" class="mb-10">
          <el-select v-model="branch" :disabled="disabledBranch" clearable placeholder="Seleccione Bodega" size="medium"
            value-key="id" filterable @change="getDataBranchSelected">
            <el-option v-for="item in branches" :key="item.id" :label="item.razon_social" :value="item.id">
            </el-option>
          </el-select>
          <!-- <branch-autocomplete-component ref="branchAutocomplete" @select="setBranch" @clear="branchId = null" /> -->
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :offset="0" class="mb-10">
          <third-autocomplete-component />
        </el-col>
        <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5" :offset="0" class="mb-10">
          <el-input v-model="numDays" placeholder="Num. Días" size="medium" clearable @change=""></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" :offset="0" class="mb-10">
          <!-- :disabled="!editDocument" -->
          <el-date-picker v-model="date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="Fecha"
            size="medium">
          </el-date-picker>
        </el-col>

        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" :offset="0" class="mb-10">
          <el-select v-model="costCenterId" clearable placeholder="Centro de costos" size="medium"
            value-key="id" filterable>
            <el-option v-for="item in costCenters" :key="item.id" :label="item.description" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" :offset="0" class="mb-10">
          <el-input v-model="document_reference" placeholder="Documento de referencia" size="medium" clearable @change="">
          </el-input>
        </el-col>
        <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" :offset="0" class="mb-10">
          <el-input v-model="observation" placeholder="Observación documento" size="medium" clearable @change="">
          </el-input>
        </el-col>
      </el-row>
    </div>
    <select-branch-component :showDialogSelectBranch="showDialogSelectBranch" @close="showDialogSelectBranch = false" />
    <print-document :show="showPrint" @close="closeModalPrint" />
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { getUser } from "@/utils/auth";
import { configBySlug } from "@/api/login";
import ListPendingComponent from "@/views/apps/inputOutputAdjust/ListPending.vue"
import ListLogComponent from "@/views/pages/administration/log/ListLog.vue"
import ThirdAutocompleteComponent from "@/views/pages/thirds/ThirdAutocomplete.vue"
import ListComponent from "./List.vue"
import SelectBranchComponent from "@/views/apps/inputOutputAdjust/SelectBranch.vue"
import PrintDocument from "@/views/apps/inputOutputAdjust/PrintDocument.vue"
import { getAll } from "@/api/store";
import { getAll as getAllCostCenter } from "@/api/costCenter";
import { printPdf, printRemissionPdf } from "@/api/document";
export default {
  components: { ListComponent, ListLogComponent, ListPendingComponent, ThirdAutocompleteComponent, SelectBranchComponent, PrintDocument },
  data() {
    return {
      user: getUser(),
      loading: false,
      showDialogSelectBranch: false,
      disabledBranch: true,
      branches: [],
      costCenters: [],
      // print
      showPrint: false,
      printDefault: null,
      idDocumentPrint: null
    };
  },
  watch: {
    refreshCodeBranch(newVal, oldVal) {
      if (newVal) {
        this.getDataBranchSelected();
      }
    },
    editDocument(newVal, oldVal) {
      if (newVal) {
        this.disabledBranch = true
      } else {
        this.disabledBranch = false
      }
    },
    inventoryAuditId(newVal, oldVal) {
      if (newVal) {
        this.disabledBranch = true
      } else {
        this.disabledBranch = false
      }
    }
  },
  created() {
    this['inputAndOutputAdjust/resetAction']()
    this.getCostCenter();
    this.getBranches();
    this.getConfigBySlug();
  },
  computed: {
    ...mapGetters(['document', 'editDocument', 'inventoryAuditId', 'refreshCodeBranch', 'execute']),
    document_reference: {
      get() { return this.document.document_reference },
      set(value) { this['inputAndOutputAdjust/SET_DOCUMENT_REFERENCE'](value) }
    },
    observation: {
      get() { return this.document.observation },
      set(value) { this['inputAndOutputAdjust/SET_OBSERVATION'](value) }
    },
    numDays: {
      get() { return this.document.numDays },
      set(value) { this['inputAndOutputAdjust/SET_NUM_DAYS'](value) }
    },
    date: {
      get() { return this.document.date },
      set(value) { this['inputAndOutputAdjust/SET_DATE'](value) }
    },
    branch: {
      get() { return this.document.branch },
      set(value) { this['inputAndOutputAdjust/SET_BRANCH']({ type: 'branch', value }) }
    },
    costCenterId: {
      get() { return this.document.costCenterId },
      set(value) { this['inputAndOutputAdjust/SET_COST_CENTER'](value ) }
    },
    codeBranch: {
      get() { return this.document.codeBranch },
      set(value) { this['inputAndOutputAdjust/SET_CODE_BRANCH'](value) }
    },
    getConsecutive() {
      if (this.document.consecutive)
        return ' - ' + this.document.consecutive
    }
  },
  methods: {
    ...mapMutations([
      'inputAndOutputAdjust/SET_THIRD_ID', 'inputAndOutputAdjust/SET_NUM_DAYS',
      'inputAndOutputAdjust/SET_DATE', 'inputAndOutputAdjust/SET_EDITING',
      'inputAndOutputAdjust/SET_OBSERVATION', 'inputAndOutputAdjust/SET_OBSERVATION',
      'inputAndOutputAdjust/SET_BRANCH', 'inputAndOutputAdjust/SET_BRANCH',
      'inputAndOutputAdjust/SET_CODE_BRANCH', 'inputAndOutputAdjust/SET_DOCUMENT_REFERENCE',
      'inputAndOutputAdjust/SET_REFRESH_CODE_BRANCH',
      'inputAndOutputAdjust/SET_COST_CENTER'
    ]),
    ...mapActions([
      'inputAndOutputAdjust/resetAction',
      'inputAndOutputAdjust/getPendingAction',
      'inputAndOutputAdjust/saveDocumentAction',
      'inputAndOutputAdjust/updateDocumentAction',
      'inputAndOutputAdjust/setDataPrintAction'
    ]),
    setBranchByRoleToUser() {
      // this.branch = parseInt(this.user.sucursal_id);
      let role = this.user.roles.find((d) => (d.guard_name === 'admin' || d.guard_name === 'deposit'));
      if (role && typeof role !== 'undefined') {
        this.disabledBranch = false;
      }
      this.getDataBranchSelected()
    },
    getCostCenter() {
      getAllCostCenter()
        .then(({ data }) => {
          this.costCenters = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getBranches() {
      getAll()
        .then(({ data }) => {
          this.branches = data;
          this.setBranchByRoleToUser();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async save() {
      let me = this
      this.loading = true
      if (this.$route.meta.typeDocument == 3) {
        this.showDialogSelectBranch = true
        this.loading = false
        return
      }
      if (this.editDocument) {
        await this['inputAndOutputAdjust/updateDocumentAction'](this.$route.meta.typeDocument)
        if (this.execute && this.printDefault && this.printDefault.on_update) {
          this.printDocument()
        }
      } else {
        await this['inputAndOutputAdjust/saveDocumentAction']({
          type: this.$route.meta.type,
          typeDocument: this.$route.meta.typeDocument
        })
        if (this.execute && this.printDefault && this.printDefault.on_save) {
          this.printDocument()
        }
      }
      setTimeout(() => {
        me.loading = false
      }, 1000);
    },
    reset() {
      this['inputAndOutputAdjust/resetAction']()
      this['inputAndOutputAdjust/getPendingAction'](this.$route.meta.typeDocument)
    },
    getDataBranchSelected() {
      let me = this
      if (this.document.branch != null) {
        const branchSelected = this.branches.find(el => el.id === this.document.branch);
        setTimeout(() => {
          if (typeof branchSelected != 'undefined') {
            me.codeBranch = branchSelected.nit
          }
          me['inputAndOutputAdjust/SET_REFRESH_CODE_BRANCH'](false)
        }, 1000);
      }
    },
    printDocument() {
      if (this.$route.meta.typeDocument == 8) {
        this.printDocumentRemissionPdf(this.document.id)
      } else {
        let me = this
        this['inputAndOutputAdjust/setDataPrintAction'](this.document.id)
        // this.showPrint = true;
        const loading = this.$loading({
          lock: true,
          text: 'Generando documento de impresión...',
          spinner: 'el-icon-loading',
          background: 'rgb(233 233 233 / 80%)'
        });
        printPdf(this.document.id).then(({ data }) => {
          this.$message.success("Documento PDF");
          // window.open(process.env.VUE_APP_ROOT+"storage/documento.pdf");
          let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
                      width=0,height=0,left=-1000,top=-1000`;
          open(process.env.VUE_APP_ROOT + "storage/documento.pdf", 'DOCUMENT', params);
          loading.close();
        }).catch((e) => {
          loading.close();
          me.$message.error("Error al generar el documento de impresión.");
          console.log(e);
        })
      }
    },
    printDocumentRemissionPdf(idDocument) {
      let me = this
      me.loadingTable = true
      const loading = this.$loading({
        lock: true,
        text: 'Generando documento de impresión...',
        spinner: 'el-icon-loading',
        background: 'rgb(233 233 233 / 80%)'
      });
      printRemissionPdf(idDocument).then(({ data }) => {
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
        width=0,height=0,left=-1000,top=-1000`;
        open(process.env.VUE_APP_ROOT + "storage/Remision.pdf", 'REMISION', params);
        me.loadingTable = false
        loading.close();
      }).catch((e) => {
        console.log(e);
        loading.close();
        me.loadingTable = false
        me.$message.error("Error al generar el documento de impresión.");
      })
    },
    closeModalPrint() {
      this.showPrint = false;
    },
    getConfigBySlug() {
      let me = this;
      configBySlug("print_default_document_on_save_to_on_update")
        .then(({ data }) => {
          if (data) {
            me.printDefault = JSON.parse(data.value)
          }
        })
        .catch(function (error) {
          console.log(error.response);
          me.$message({
            type: "error",
            message: "Error! " + error.response,
          });
        });
    },
  },
};
</script>

<style lang="css" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 175px;
}

.el-button {
  margin-left: 0px;
}

.flex-menu-one {
  display: flex;
  gap: 10px;
}

.flex-menu {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 1000px) {

  .flex-menu,
  .flex-menu-one {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
</style>